import type { IContractor } from "@/types/users-contractors";
import { useBoolean } from "@/ui-kit";
import EditModal from "./EditModal";
import { useCallback, useState } from "react";
import { ExperienceCard } from "@/components/profile-cards";

type IProps = {
  profile: IContractor;
};

export const Experience = ({ profile }: IProps) => {
  const [values, setValues] = useState<IContractor>(profile);

  const updateValues = useCallback((v: IContractor) => {
    setValues(v);
  }, []);

  const {
    value: showEditUserModal,
    setTrue: openEditUserModal,
    setFalse: dismissEditUserModal,
  } = useBoolean(false);

  return (
    <>
      <ExperienceCard
        expertise={values.expertise}
        yearsOfExperience={values.yearsOfExperience}
        onEdit={openEditUserModal}
      />
      {showEditUserModal && (
        <EditModal
          profile={values}
          onSave={updateValues}
          onDismiss={dismissEditUserModal}
        />
      )}
    </>
  );
};
